module.exports = __webpack_public_path__ + "img/myanmar.56145926.svg";